import initMapBlock from './map-block';

export default () => {
  initMapBlock();
};
